import { jsCompletions, jsSignature, jsHover } from './js-source.js'
import { sqlCompletions, sqlHover } from './sql-source.js'
import { pythonCompletions, pythonSignature, pythonHover } from './python-source.js'
import type { CompletionSource, HoverSource, SignatureSource } from './types.js'

export interface LanguageIntel {
  complete: CompletionSource
  signature?: SignatureSource
  hover?: HoverSource
  /** Characters that open the popup on their own (besides identifier characters). */
  triggers: string
}

/** The code intelligence for an editor `language` (the highlight.js name), or null. */
export function intelForLanguage(language: string | undefined): LanguageIntel | null {
  switch (language) {
    case 'javascript':
    case 'typescript':
    case 'html':
      return { complete: jsCompletions, signature: jsSignature, hover: jsHover, triggers: `.'"\`` }
    case 'sql':
      return { complete: sqlCompletions, hover: sqlHover, triggers: '.@:' }
    case 'python':
      return { complete: pythonCompletions, signature: pythonSignature, hover: pythonHover, triggers: `.'"` }
    default:
      return null
  }
}
